import styled from "@emotion/styled";
import { Col, Empty, Row } from "antd";
import { CustomButon } from "./CommonHeader";
import touzi4 from "../../../../images/touzi-4.png";
import jiansheImg from "../../../../images/jianshe-4.png";
import jianshebox from "../../../../images/jianshe-box.png";
import jiansheActive from "../../../../images/jianshe-item.png";
import { useEffect, useState } from "react";
import request from "../../../../utils/request";
import { useCallback } from "react";
import classNames from "classnames";
import { EmptyPage } from "./Empty";

const Layout = styled.div`
  .ant-empty-description {
    color: #fff;
  }
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;
  }

  .title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #feffff;
    margin-bottom: 20px;
  }
  .touzi {
    margin-top: 43px;
    &-title {
      align-items: center;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      img {
        margin-right: 19px;
      }
    }
    .touzi-info {
      margin-top: 27px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      .value {
        font-weight: 400;
      }
    }
  }
  .jianshe {
    margin-top: 48px;
    &-title {
      align-items: center;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      img {
        margin-right: 19px;
      }
    }
    .ant-col {
      margin-bottom: 30px;
    }
    &-info {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      margin-top: 25px;
      .jianshe-box {
        width: 341px;
        height: 41px;
        background-image: url(${jianshebox});
        align-items: center;
        .status-item {
          flex: 1;
          height: 30px;
          text-align: center;
          line-height: 30px;
        }
        .active {
          background-image: url(${jiansheActive});
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
      .label {
        margin-right: 95px;
      }
      .value {
        font-weight: 400;
      }
    }
  }
`;
type ProjectType = "getCompanyProject" | "getProjectDetails" | "economyDetails";
export const Project: React.FC<{ id?: number; type?: ProjectType }> = ({
  id,
  type = "getCompanyProject",
}) => {
  const [details, setDetails] = useState<Record<string, any>[]>([]);
  const className = type === "getCompanyProject" ? "box-item" : "";
  const isEconomy = type === "economyDetails";
  const getData = useCallback(() => {
    if (!id) return;
    const url = `/screen/Index/${type}?id=`;
    request.get(url + id).then((res) => {
      console.log("res", res);
      const tempRes = res.data?.data
        ? Array.isArray(res.data?.data)
          ? res.data?.data
          : [res.data?.data]
        : [];
      setDetails(tempRes);
    });
  }, [id]);
  useEffect(() => {
    getData();
  }, [getData]);
  if (!details?.length) {
    return (
      <Layout>
        <Empty description="暂无数据" style={{ color: "#fff" }} />
      </Layout>
    );
  }
  return (
    <Layout>
      {/* {
      !details?.length &&   <Empty description="暂无数据" style={{ color: "#fff" }} />
      } */}
      {details.map((data: Record<string, any>) => {
        return (
          <div className={className} key={data.id}>
            <div className="title">{data.name}</div>
            <Row gutter={0}>
              {data?.tags_ary?.map((item: Record<string, any>) => {
                return (
                  <Col key={item.id}>
                    <CustomButon bgColor={"#CDF7E2"} color="#34A76E">
                      {item.dkey}
                    </CustomButon>
                  </Col>
                );
              })}
            </Row>
            <div className="touzi">
              <div className="flex touzi-title">
                <img src={touzi4} width="30px" height="30px" alt="" />
                <span>投资信息</span>
              </div>
              <Row gutter={124} className="touzi-info">
                {isEconomy && (
                  <Col span={6}>
                    <div className="flex ac">
                      <div className="label" style={{ marginRight: "8px" }}>
                        投资方:{" "}
                      </div>
                      <div className="value">{data.qyinvester}</div>
                    </div>
                  </Col>
                )}
                <Col span={6}>
                  <div className="flex ac">
                    <div className="label">总投资（亿元）</div>
                    <div className="value">{data.proj_funding}</div>
                  </div>
                </Col>
                {!isEconomy && (
                  <Col span={6}>
                    <div className="flex ac">
                      <div className="label">固定资产投资（亿元）</div>
                      <div className="value">{data.gdzctz}</div>
                    </div>
                  </Col>
                )}
              </Row>
            </div>

            <div className="jianshe">
              <div className="flex jianshe-title ac">
                <img src={jiansheImg} width="30px" height="30px" alt="" />
                <span>建设信息</span>
              </div>
              <Row gutter={60} className="jianshe-info">
                {!isEconomy && (
                  <>
                    <Col span={12}>
                      <div className="flex ac">
                        <div className="label">建设阶段</div>
                        <div className="value">
                          <div className="jianshe-box flex">
                            <div
                              className={classNames("status-item", {
                                active: data.is_status === 4,
                              })}
                            >
                              储备
                            </div>
                            <div
                              className={classNames("status-item", {
                                active: data.is_status === 1,
                              })}
                            >
                              开工
                            </div>
                            <div
                              className={classNames("status-item", {
                                active: data.is_status === 2,
                              })}
                            >
                              续建
                            </div>
                            <div
                              className={classNames("status-item", {
                                active: data.is_status === 3,
                              })}
                            >
                              竣工
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="flex ac">
                        <div className="label">批次</div>
                        <div className="value">{data.pici || "--"}</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="flex ac">
                        <div className="label">建设期限开始时间</div>
                        <div className="value">{data.startdate || "--"}</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="flex ac">
                        <div className="label">建设期限结束时间</div>
                        <div className="value">
                          {data.completiondate || "--"}
                        </div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="flex ac">
                        <div className="label">建设单位负责人</div>
                        <div className="value">
                          {data.tzresponsibler || "--"}
                        </div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="flex ac">
                        <div className="label">联系方式</div>
                        <div className="value">{data.tzlxdh || "--"}</div>
                      </div>
                    </Col>
                  </>
                )}
                <Col span={24}>
                  <div className="flex  column">
                    <div className="label">建设规模及内容</div>
                    <div className="value">{data.overview || "--"}</div>
                  </div>
                </Col>
                {!isEconomy && (
                  <Col span={24}>
                    <div className="flex  column">
                      <div className="label">备注</div>
                      <div className="value">{data.overview2 || "--"}</div>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        );
      })}
    </Layout>
  );
};
